import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  getAllTenantPreference: [],
  tenantPreference: [],
};

export const TenantPreferenceSlice = createSlice({
  name: "tenantPreference",
  initialState,
  reducers: {
    getTenantPreferenceAction: (state, action) => {
      state.getAllTenantPreference = action.payload;
    },
    getSingleTenantPreference: (state, action) => {
      state.tenantPreference = action.payload;
    }
  },
});

export default TenantPreferenceSlice.reducer;

export const { getTenantPreferenceAction, getSingleTenantPreference } = TenantPreferenceSlice.actions;
